import Image from '@anm/components/image/Image';
import { FC } from 'react';

import { ConnectButtonWrapper } from '../../Wrapper';
import { ConnectButtonProps } from '../../types';

const ConnectButton: FC<ConnectButtonProps> = ({ onReconnect }) => (
  <ConnectButtonWrapper onClick={onReconnect}>
    <Image src={'images/dashboard/replace_black.svg'} alt="connect button" />
    <span>Reconnect</span>
  </ConnectButtonWrapper>
);

export default ConnectButton;
